(() => {
  const setText = (el, text) => { if (el) el.textContent = text || ''; };
  const largerImage = (src) => {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', '900');
      return url.toString();
    } catch (_) { return src; }
  };

  const makeQuickView = (module) => {
    let dialog = module.querySelector('[data-complete-look-quick]');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'complete-look-quick';
    dialog.setAttribute('data-complete-look-quick', '');
    dialog.setAttribute('aria-labelledby', 'complete-look-quick-title');
    dialog.innerHTML = `
      <button type="button" class="complete-look-quick__close" data-complete-look-quick-close aria-label="Close quick view">×</button>
      <div class="complete-look-quick__layout">
        <div class="complete-look-quick__media"><img class="complete-look-quick__image" data-complete-look-quick-image alt=""></div>
        <div class="complete-look-quick__content">
          <div class="complete-look-quick__eyebrow">Complete the Look</div>
          <h2 class="complete-look-quick__title" id="complete-look-quick-title" data-complete-look-quick-title></h2>
          <div class="complete-look-quick__variant" data-complete-look-quick-variant></div>
          <div class="complete-look-quick__price" data-complete-look-quick-price></div>
          <p class="complete-look-quick__note">Selected to complement the colorway you’re viewing.</p>
          <button type="button" class="complete-look-quick__add" data-complete-look-quick-add>Add handbag</button>
          <div class="complete-look-quick__status" data-complete-look-quick-status role="status" aria-live="polite"></div>
          <button type="button" class="complete-look-quick__continue" data-complete-look-quick-close>Continue with this shoe</button>
        </div>
      </div>`;
    module.appendChild(dialog);
    return dialog;
  };

  const cardMatchesVariant = (card, variantId) => {
    if (!card || !variantId) return false;
    const id = String(variantId);
    const grouped = String(card.dataset.shoeVariants || '');
    if (grouped && grouped.includes(`|${id}|`)) return true;
    return String(card.dataset.shoeVariant || '') === id;
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-complete-look]').forEach((module) => {
      if (module.dataset.initialized === 'true') return;
      module.dataset.initialized = 'true';

      const dialog = makeQuickView(module);
      let opener = null;
      let activeCard = null;

      const show = (variantId) => {
        if (!variantId) return;
        let active = null;

        module.querySelectorAll('[data-complete-look-card]').forEach((card) => {
          const match = cardMatchesVariant(card, variantId);
          card.hidden = !match;
          if (match) active = card;
        });

        activeCard = active;
        module.hidden = !active;
        if (dialog.open && !active) dialog.close();
      };

      const openQuick = (trigger) => {
        const card = trigger.closest('[data-complete-look-card]');
        if (!card || card.hidden) return;

        activeCard = card;
        const image = card.querySelector('.complete-look__image');
        const title = card.querySelector('.complete-look__title');
        const variant = card.querySelector('.complete-look__variant');
        const price = card.querySelector('.complete-look__price');
        const modalImage = dialog.querySelector('[data-complete-look-quick-image]');

        modalImage.src = largerImage(image?.currentSrc || image?.src || '');
        modalImage.alt = title?.textContent?.trim() || 'Recommended handbag';
        setText(dialog.querySelector('[data-complete-look-quick-title]'), title?.textContent?.trim());
        setText(dialog.querySelector('[data-complete-look-quick-variant]'), variant?.textContent?.trim());
        setText(dialog.querySelector('[data-complete-look-quick-price]'), price?.textContent?.trim());
        setText(dialog.querySelector('[data-complete-look-quick-status]'), '');

        const quickAdd = dialog.querySelector('[data-complete-look-quick-add]');
        quickAdd.disabled = false;
        quickAdd.classList.remove('is-added');
        setText(quickAdd, 'Add handbag');
        opener = trigger;

        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };

      const submitActiveBag = async (quickAdd) => {
        const card = activeCard && !activeCard.hidden
          ? activeCard
          : module.querySelector('[data-complete-look-card]:not([hidden])');
        const inlineAdd = card?.querySelector('[data-sss-bag-add], .complete-look__add');
        const status = dialog.querySelector('[data-complete-look-quick-status]');
        const variantId = inlineAdd?.dataset.variantId || card?.querySelector('[name="id"]')?.value;

        if (!inlineAdd || !variantId) {
          setText(status, 'Unable to add this handbag. Please try again.');
          return;
        }

        quickAdd.disabled = true;
        setText(quickAdd, 'Adding…');
        setText(status, '');

        try {
          const cartDrawer = document.querySelector('cart-drawer');
          const sectionIds = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
            ? cartDrawer.getSectionsToRender().map((section) => section.id)
            : ['cart-drawer', 'cart-icon-bubble'];

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds,
              sections_url: window.location.pathname
            })
          });

          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add this handbag. Please try again.');
          }

          if (typeof dialog.close === 'function' && dialog.open) dialog.close();
          else dialog.removeAttribute('open');

          if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({
              ...data,
              id: data.id || data.items?.[0]?.id || Number(variantId)
            });
          } else if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined' &&
            PUB_SUB_EVENTS.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'complete-the-look',
              productVariantId: Number(variantId)
            });
          }

          quickAdd.classList.add('is-added');
          setText(quickAdd, 'Added to bag');
          setText(status, 'Handbag added to your bag.');

          window.setTimeout(() => {
            if (!quickAdd.isConnected) return;
            quickAdd.disabled = false;
            quickAdd.classList.remove('is-added');
            setText(quickAdd, 'Add handbag');
          }, 2200);
        } catch (error) {
          quickAdd.disabled = false;
          setText(quickAdd, 'Add handbag');
          setText(status, error?.message || 'Unable to add this handbag. Please try again.');
        }
      };

      show(module.dataset.initialVariant);

      module.addEventListener('click', (event) => {
        const trigger = event.target.closest('.complete-look__media, .complete-look__title');
        if (trigger && trigger.closest('[data-complete-look-card]')) {
          event.preventDefault();
          openQuick(trigger);
          return;
        }

        const close = event.target.closest('[data-complete-look-quick-close]');
        if (close) {
          event.preventDefault();
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
          return;
        }

        const add = event.target.closest('[data-complete-look-quick-add]');
        if (add) {
          event.preventDefault();
          submitActiveBag(add);
        }
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;
        if (!inside && typeof dialog.close === 'function') dialog.close();
      });

      dialog.addEventListener('close', () => {
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      });

      document.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
        if (input.closest('[data-complete-look]')) return;
        const form = input.closest('form[id^="product-form-"]');
        if (!form) return;
        show(input.value);
      });

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange
      ) {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variantId = event?.data?.variant?.id;
          if (variantId) show(variantId);
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
